import {DesignStudioChooseCategoryOptionForm} from "./DesignStudioChooseCategoryOptionForm";
import {getSingleInputByNameV3} from "../helpers/inputs/forms/fornInputHelpers";
import Axios from "axios";
import {hideLoading, showLoading} from "../helpers/loading";
import {handleAjaxSuccess} from "../helpers/SwalHelper";
import handleAjaxError from "../helpers/handleAjaxError";
import {displayLocalValidationError} from "../helpers/forms/validationErrors/utils";
import {clearFeedbacksByName} from "../helpers/forms";
import {scrollToElement} from "../helpers/scrolling/scrolling";
import {updateProgressBar} from "../helpers/progressBar/progressBar";

function initCustomerDesignStudioShowSummary() {
	/** @var {DesignStudioChooseCategoryOptionForm[]} */
	const categoryForms = [];

	// Initialize each category form
	document.querySelectorAll('.categories-summary-container .design-studio-choose-category-option-form')
		.forEach(formContainer => {
			const parentCard = formContainer.closest('.card');
			const parentCategoryBody = formContainer.closest('.category-body');

			const form = new DesignStudioChooseCategoryOptionForm({
				formElement: formContainer,
				onSelection: (selection) => {
					updateCategoryHeader(form, selection)
					updateMainHeader();
					// submitChanges(true);
				}
			})

			categoryForms.push(form);

			// Get related header
			const relatedHeaderContainer = parentCard.querySelector(`.category-header[data-category-id="${parentCategoryBody.dataset.categoryId}"]`)

			// Setup clear button
			const clearSelectionButton = relatedHeaderContainer.querySelector('.clear-selection-button');
			clearSelectionButton.addEventListener('click', () => {
				form.clearCustomerSelection();
			})

			// Initial render
			updateCategoryHeader(form, form.getCustomerSelection())
		});

	// Setup submit button
	document.querySelector('.confirm-button')
		.addEventListener('click', () => {
			submitChanges();
		})

	// Open first entry
	document.querySelector('.category-header:first-of-type').click();

	// Initial render
	updateMainHeader();

	// Scroll window to bottom to center page
	document.documentElement.scrollTop = 10000;

	// Methods

	/**
	 * @param {DesignStudioChooseCategoryOptionForm} form
	 * @param {DesignStudioChooseCategoryOptionFormDefs.CustomerSelection} selection
	 */
	function updateCategoryHeader(form, selection) {
		// Retrieve parent header
		const card = form.config.formElement.closest('.card');

		// Get category header
		const categoryHeaderContainer = card.querySelector(`.category-header[data-category-id="${selection.category_id}"]`);

		// Get selection container in header
		const selectionContainer = categoryHeaderContainer.querySelector(`.current-selection`);

		const removeReselectionButton = categoryHeaderContainer.querySelector('.clear-selection-button');

		const noSelection =
			/// If per area options is not selected ...
			selection.per_area_options.length === 0 &&
			// ... and no selection exists ...
			(!selection.option || (!selection.option.option_id && !selection.option.custom_choice && !selection.option.ideas_board_post_id));

		if (noSelection) {
			selectionContainer.innerHTML = 'None';
			// Hide clear button
			removeReselectionButton.classList.add('hidden');
			// Clear filled class flag
			categoryHeaderContainer.classList.remove('filled');
		} else {
			if (isPerAreaSelection(selection)) {
				// Get per area progress
				const totalOptions = selection.per_area_options.length;
				const perAreaProgress = getPerAreaSelectedOptions(selection).length;

				// Per area selection
				selectionContainer.innerHTML = `Per Area<br>${perAreaProgress} / ${totalOptions}`;

				// Hide clear button
				removeReselectionButton.classList.add('hidden');

				if (isPerAreaSelectionCompleted(selection)) {
					// Add filled class flag
					categoryHeaderContainer.classList.add('filled');
				} else {
					// Clear filled class flag
					categoryHeaderContainer.classList.remove('filled');
				}
			} else {
				// Project wide selection
				let selectionName;
				if (selection.option.custom_choice || selection.option.ideas_board_post_id) {
					selectionName = 'Custom Choice';
				} else {
					selectionName = selection.option.name ? selection.option.name : 'None';
				}
				selectionContainer.innerHTML = selectionName;

				// Make clear button visible
				removeReselectionButton.classList.remove('hidden');

				// Add filled class flag
				categoryHeaderContainer.classList.add('filled');
			}
		}
	}

	/**
	 * @param silent
	 */
	function submitChanges(silent = false) {
		const submitRoute = getSingleInputByNameV3(document.body, 'submit_route');

		const data = {
			categories: categoryForms.map(form => form.getCustomerSelection()),
		}

		clearFeedbacksByName(document.body);

		if (silent === false) {
			// Validate that all per area rooms are selected
			for (const category of data.categories) {
				if (category.per_area_options.length > 0) {
					// Is per area selection
					for (const option of category.per_area_options) {
						// If option has not been filled
						if (option.option.option_id === '') {
							// Show validation error
							const relatedErrorContainer = document.querySelector(`.customizable-error-container[data-category-id="${category.category_id}"]`)
							displayLocalValidationError(relatedErrorContainer, 'dummy-input-field', 'Please make a selection for all rooms');

							// Scrolling to warning seems to be bugged so we call it twice
							scrollToElement(document.querySelector('.invalid-feedback.d-block'));

							// End early
							return;
						}
					}
				}
			}

			showLoading();
		}

		Axios.post(submitRoute, data)
			.then(response => {
				if (silent === false) {
					handleAjaxSuccess(response);
				}
			})
			.catch(handleAjaxError)
			.finally(() => {
				if (silent === false) {
					hideLoading();
				}
			})
	}


	/**
	 * @param {DesignStudioChooseCategoryOptionFormDefs.CustomerSelection} selection
	 * @return {boolean}
	 */
	function isPerAreaSelection(selection) {
		return selection.option === undefined;
	}

	/**
	 * Checks if all areas have a choice for the given customer choice
	 *
	 * @param {DesignStudioChooseCategoryOptionFormDefs.CustomerSelection} selection
	 * @return {boolean}
	 */
	function isPerAreaSelectionCompleted(selection) {
		// If not a per area selection
		if (selection.per_area_options.length === 0) {
			return true;
		}

		for (const option of selection.per_area_options) {
			// If option has not been filled
			if (option.option.option_id === '') {
				// return false, end early
				return false;
			}
		}

		// All filled
		return true;
	}

	/**
	 * Returns the entries that have been selected
	 *
	 * @param {DesignStudioChooseCategoryOptionFormDefs.CustomerSelection} selection
	 * @return {DesignStudioChooseCategoryOptionFormDefs.PerAreaSelection[]}
	 */
	function getPerAreaSelectedOptions(selection) {
		return selection.per_area_options.filter(option => {
			// Option has been selected or is custom choice
			return option.option.option_id || option.option.custom_choice
		})
	}

	function updateMainHeader() {
		const mainHeader = document.querySelector('.main-card-header');
		const totalChoicesCounterElement = mainHeader.querySelector('.total-choices-counter');
		/** @var {HTMLElement} */
		const progressBarElement = mainHeader.querySelector('.component-progress-bar');

		const totalCategories = categoryForms.length;
		const filledCategories = [];
		// Get finished categories count
		categoryForms.forEach(form => {
			const selection = form.getCustomerSelection();

			if (selectionIsComplete(selection)) {
				filledCategories.push(form);
			}
		})

		// Display options missing
		const categoriesPending = totalCategories - filledCategories.length;

		if (categoriesPending) {
			totalChoicesCounterElement.innerHTML = `
				${categoriesPending} Choice${categoriesPending > 1 ? 's' : ''} Pending
			`;
		} else {
			totalChoicesCounterElement.innerHTML = `
				<div class="d-flex align-items-center">
					<div class="title-check-icon d-flex justify-content-center align-items-center mr-2">
						<i
							class="mdi mdi-check-circle-outline green-success-font"
							style="font-size: 1.8rem; line-height: 0"
						>
						</i>
					</div>
					Completed
				</div>
			`
		}

		// Update progress bar
		const progressInPercentage = (filledCategories.length / totalCategories) * 100;

		updateProgressBar(progressBarElement, progressInPercentage)

	}

	/**
	 * Checks if the given selection is valid
	 *
	 * @param {DesignStudioChooseCategoryOptionFormDefs.CustomerSelection} selection
	 * @return {boolean}
	 */
	function selectionIsComplete(selection) {
		const noSelection =
			/// If per area options is not selected ...
			selection.per_area_options.length === 0 &&
			// ... and no selection exists ...
			(!selection.option || (!selection.option.option_id && !selection.option.custom_choice && !selection.option.ideas_board_post_id));

		if (noSelection) {
			// No selection has been made yet
			return false;
		}

		if (isPerAreaSelection(selection)) {
			return isPerAreaSelectionCompleted(selection)
		}

		// Must be project wide selection already selected
		return true;
	}
}

export {initCustomerDesignStudioShowSummary}
